import Header from "./Header"
import Footer from './Footer'
import Sidebar from './Sidebar'

const Layout = ({ children }) => {
    return (
        <div className="layout-wrapper">
            <Header />
            <div className="content-section">
                {/*<Sidebar />*/}
                <div className="section">
                    {children}
                </div>
            </div>
            <Footer isLoggedIn="True" />
        </div>
    )
}

export default Layout